import styled from '@mui/system/styled'
import Container from '@mui/material/Container'

const ButtonStack = styled(Container)`
  display: flex;
  margin: 3px 0;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export default ButtonStack
